import React from "react";
import { List, Datagrid, EditButton, DeleteWithConfirmButton, ShowButton, DateField, TextField } from "react-admin";
import { dateOptions } from "../../../../utils/options";
import { EmptyList } from "../../../../common/components";

const CompanyList = () => {
  return (
    <List
      title="Кампании"
      sort={{ field: "id", order: "DESC" }}
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="Заглавие"
          source="name_bg"
          sortable={false}
        />
        <DateField
          label="Начална дата на абонаментната кампания"
          source="start_date"
          locales={"bg"}
          options={dateOptions}
          fullWidth
          sortable={false}
        />
        <DateField
          label="Крайна дата на абонаментната кампания"
          source="end_date"
          locales={"bg"}
          options={dateOptions}
          fullWidth
          sortable={false}
        />
        <DateField
          label="Дата на начало на абонаментите"
          source="subscription_start_date"
          locales={"bg"}
          options={dateOptions}
          fullWidth
          sortable={false}
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default CompanyList;
